import React, {Component} from "react";
import looker_studio_logo from '../../images/logo_looker_studio.png';

export class LookerStudioLogo extends Component {

    getHspace() {
        if(this.props.hspace !== undefined)
            return this.props.hspace;
        return 10;
    }

    getVspace() {
        if(this.props.vspace !== undefined)
            return this.props.vspace;
        return 10;
    }

    getWidth() {
        return this.props.width || 20;
    }

    getHeight() {
        return this.props.height || 20;
    }

    getImage() {
        return looker_studio_logo;
    }

    getStyle() {
        const style = this.props.styles ? {...this.props.styles} : {};
        if (this.props.color === 'grey') {
            style.filter = 'grayscale(100%)';
        } else if (this.props.color === 'green') {
            style.filter = 'invert(48%) sepia(79%) saturate(2476%) hue-rotate(86deg) brightness(118%) contrast(119%)';
        }
        return style;
    }

    render() {
        return <img alt="Looker Studio" style={this.getStyle()} src={this.getImage()} height={this.getHeight()}
                    width={this.getWidth()} hspace={this.getHspace()} vspace={this.getVspace()}
        />
    }
}
